import useResponsive from "core/hooks/useResponsive";
import Carousel from "../Carousel/Carousel";
import { useIntl } from "react-intl";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import { Link } from "react_reusable_components";
import { ArrowLeftOutlined } from "@ant-design/icons";
import DensoLogo from "../DensoLogo/DensoLogo";
import Style from "./Banner.module.scss";
import HeadingContainer from "../../containers/HeadingContainer";
import { useNavigate } from "react-router-dom";

function Banner() {
  const intl = useIntl();
  const responsive = useResponsive();
  const navigate = useNavigate();

  let showLogo = window.location.pathname === "/login" && !responsive?.isMd;
  let showBackBtn = window.location.pathname !== "/login" && !responsive?.isMd;
  let heading = "login.welcomeToOurCommunity";
  let description = "login.headingDescription";
  let backLink = "/login";

  if (!responsive.isMd) {
    if (window.location.pathname === "/login") {
      heading = "login.welcomeBack";
    } else if (window.location.pathname === "/login/otp") {
      heading = "login.enterOtp";
      description = "login.otpHasBeenShared";
    } else if (window.location.pathname === "/login/forgot-password") {
      heading = "login.forgotPassword";
      description = "login.forgotDescription";
    } else if (
      window.location.pathname.includes(`/login/forgot-password/`) &&
      window.location.pathname.length > "/login/forgot-password/".length
    ) {
      heading = "login.createNewPassword";
      description = "login.differentPassword";
      backLink = "/login/forgot-password";
    }
  }

  return (
    <div
      className={`${
        Style[responsive.isMd ? "Carousel-md" : "Carousel-mb"]
      } relative`}
    >
      {showLogo && <DensoLogo className={Style["denso-banner-logo"]} />}
      {showBackBtn && (
        <Link
          onClick={(e) => {
            e.preventDefault();
            navigate(backLink);
          }}
          strong
          className={Style["denso-back-arrow"]}
        >
          <ArrowLeftOutlined
            className={`${Style["color-text-banner"]} ${Style["arrow-size"]}`}
          />
        </Link>
      )}
      <div className={Style[responsive.isMd ? "heading" : "headingMb"]}>
        <HeadingContainer
          headingClassName={Style["heading-banner"]}
          descriptionClassName={Style["color-text-banner"]}
          description={getLocalizedMessage(intl, description)}
          heading={getLocalizedMessage(intl, heading)}
          level={1}
        />
      </div>
      <Carousel />
    </div>
  );
}

Banner.propTypes = {};

export default Banner;
